require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-sarah-fischer.json") })
        }
      }, "path---blog-author-sarah-fischer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-sarah-fischer!./.cache/json/blog-author-sarah-fischer.json
// module id = 704
// module chunks = 231608221292675